export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  routineDestroySuccess: 'Routine successfully deleted!',
  routineDestroyFailure: 'Unable to delete routine',
  routineCreateSuccess: 'Routine successfully created!',
  routineCreateFailure: 'Unable to create routine',
  routineEditSuccess: 'Routine successfully edited!',
  routineEditFailure: 'Unable to edit routine',
  emptyField: 'No empty fields here!',
  numReps: 'Choose rep counts between 1 and 12'
}



// WEBPACK FOOTER //
// ./src/auth/messages.js